import { useEffect } from 'react';
import type { ReactNode } from 'react';

interface Props {
  title: string;
  onClose: () => void;
  children: ReactNode;
}

/** Visar utkastet med sajtens egna komponenter, ovanpå admin-vyn. */
export default function PreviewOverlay({ title, onClose, children }: Props) {
  useEffect(() => {
    function onKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  return (
    <div className="preview-backdrop" role="dialog" aria-modal="true" aria-label={title}>
      <div className="preview-window">
        <div className="preview-bar">
          <div>
            <span className="preview-label">Förhandsgranskning</span>
            <strong>{title}</strong>
          </div>
          <button className="button secondary small" type="button" onClick={onClose}>
            Stäng
          </button>
        </div>
        <div className="preview-body">{children}</div>
      </div>
    </div>
  );
}
